import { createStore } from 'vuex'

import { app } from '@/store/app'
import { auth } from '@/store/auth'
import { cache } from '@/store/cache'
import { clothing } from '@/store/clothing'
import { hunter } from '@/store/hunter'
import { riddle } from '@/store/riddle'
import { seo } from '@/store/seo'

export default createStore({
  modules: {
    app,
    auth,
    cache,
    clothing,
    hunter,
    riddle,
    seo,
  },
})
